// Feature flags for Visit Management system
// These can be toggled per clinic or globally

export interface VisitFeatureFlags {
  requireQRForVisitStart: boolean;
  lockVisitAfterHours: number; // 0 = disabled, >0 = hours after signing
  enableInventoryLink: boolean;
  enableBilling: boolean;
  editWindowMinutes: number; // Minutes after signing when edit is allowed
  enableAutomaticReminders: boolean;
  enablePDFGeneration: boolean;
  enableOptimisticLocking: boolean;
}

export const DEFAULT_VISIT_FLAGS: VisitFeatureFlags = {
  requireQRForVisitStart: false,
  lockVisitAfterHours: 12,
  enableInventoryLink: true,
  enableBilling: true,
  editWindowMinutes: 30,
  enableAutomaticReminders: true,
  enablePDFGeneration: true,
  enableOptimisticLocking: true
};

// Load from localStorage (per-clinic override) or use defaults
export const getVisitFeatureFlags = (clinicId?: string): VisitFeatureFlags => {
  try {
    const stored = localStorage.getItem(`visit-flags-${clinicId || 'global'}`);
    if (stored) {
      return { ...DEFAULT_VISIT_FLAGS, ...JSON.parse(stored) };
    }
  } catch (e) {
    console.error('Error loading visit feature flags:', e);
  }
  return DEFAULT_VISIT_FLAGS;
};

export const setVisitFeatureFlags = (flags: Partial<VisitFeatureFlags>, clinicId?: string): void => {
  try {
    const current = getVisitFeatureFlags(clinicId);
    const updated = { ...current, ...flags };
    localStorage.setItem(`visit-flags-${clinicId || 'global'}`, JSON.stringify(updated));
  } catch (e) {
    console.error('Error saving visit feature flags:', e);
  }
};

